export const KB: number = 1024;
export const MB: number = 1024 * KB;
export const GB: number = 1024 * MB;
